import { useMemo } from 'react';
import { useMutation } from 'react-query';
import AffordableWaitlistService from '../../services/affordableWaitlistService';

export const useDenyFromWaitlist = ({
  organizationId,
  propertyId,
  options,
}) => {
  const affordableWaitlistService = useMemo(
    () => new AffordableWaitlistService(),
    [],
  );
  const mutation = useMutation(
    ({ payload, affordableWaitlistId }) =>
      affordableWaitlistService.denyFromWaitlist(
        organizationId,
        propertyId,
        affordableWaitlistId,
        payload,
      ),
    options,
  );

  return { ...mutation };
};

export const useCancelFromWaitlist = ({
  organizationId,
  propertyId,
  options,
}) => {
  const affordableWaitlistService = useMemo(
    () => new AffordableWaitlistService(),
    [],
  );
  const mutation = useMutation(
    ({ payload, affordableWaitlistId }) =>
      affordableWaitlistService.cancelFromWaitlist(
        organizationId,
        propertyId,
        affordableWaitlistId,
        payload,
      ),
    options,
  );

  return { ...mutation };
};

// `fullError: true` gets the raw Boom body (`{ statusCode, error, message }`)
// on the reject path instead of just its message string — the wrapper
// components' onError needs the statusCode to tell a mode-mismatch 400 apart
// from anything else.
export const useReinstateFromWaitlist = ({
  organizationId,
  propertyId,
  options,
}) => {
  const affordableWaitlistService = useMemo(
    () => new AffordableWaitlistService(),
    [],
  );
  const mutation = useMutation(
    ({ applicationId, payload }) =>
      affordableWaitlistService.reinstateFromWaitlist(
        organizationId,
        propertyId,
        applicationId,
        payload,
        { fullError: true },
      ),
    options,
  );

  return { ...mutation };
};

// `fullError: true` for the same reason reinstate needs it: the wrapper's
// onError shows the backend's own refusal message.
export const useAddToWaitlist = ({ organizationId, propertyId, options }) => {
  const affordableWaitlistService = useMemo(
    () => new AffordableWaitlistService(),
    [],
  );
  const mutation = useMutation(
    ({ applicationId, payload }) =>
      affordableWaitlistService.addToWaitlistV2(
        organizationId,
        propertyId,
        applicationId,
        payload,
        { fullError: true },
      ),
    options,
  );

  return { ...mutation };
};

export const useEditAffordableWaitlist = ({
  organizationId,
  propertyId,
  options,
}) => {
  const affordableWaitlistService = useMemo(
    () => new AffordableWaitlistService(),
    [],
  );
  const mutation = useMutation(
    ({ applicationId, payload }) =>
      affordableWaitlistService.editAffordableWaitlist(
        organizationId,
        propertyId,
        applicationId,
        payload,
        { fullError: true },
      ),
    options,
  );

  return { ...mutation };
};

export const useCancelKeepInProcess = ({
  organizationId,
  propertyId,
  options,
}) => {
  const affordableWaitlistService = useMemo(
    () => new AffordableWaitlistService(),
    [],
  );
  const mutation = useMutation(
    ({ payload, affordableWaitlistId }) =>
      affordableWaitlistService.cancelKeepInProcessFromWaitlist(
        organizationId,
        propertyId,
        affordableWaitlistId,
        payload,
      ),
    options,
  );

  return { ...mutation };
};
